import Vue from 'vue';
import VueRouter from 'vue-router';
import authCheck from '@/mixins/auth-check';
import routeBeforeEach from './route-before-each';
import routes from './routes';

Vue.use(VueRouter);
Vue.mixin(authCheck);

const router = new VueRouter({
	mode: 'history',
	base: process.env.VUE_APP_BASE,
	routes
});

router.beforeEach(routeBeforeEach);

export default router;
